import React from 'react'
import AppFooter from '../../components/AppFooter/AppFooter';
import AppRegister from '../../components/AppRegister/AppRegister';

export default function Register() {
  return (
    <div>
      <AppRegister />
      <AppFooter />
    </div>
  );
}
